import Table from './Table';
export default Table;


//////////////////
// WEBPACK FOOTER
// ../~/antd/es/table/index.js
// module id = 807
// module chunks = 0